import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    const onScroll = () => {
      if (!anchor) {
        setVisible(window.scrollY > 600);
        return;
      }
      const bottom = anchor.getBoundingClientRect().bottom;
      setVisible(bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-174" data-mp="brkhom9jy9pr">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3" data-id="element-175" data-mp="bookx19fxr2w">
          <div className="mx-auto max-w-xl rounded-2xl border border-white/10 bg-navy-900/95 p-2.5 shadow-[0_-8px_30px_-10px_rgba(0,0,0,0.6)] backdrop-blur" data-id="element-176" data-mp="2b2yx9kp0y3jg">
            <a href={CHECKOUT_URL} className="flex animate-shake items-center justify-center gap-2 rounded-xl bg-gold-500 px-4 py-3.5 text-center text-[13px] font-extrabold uppercase leading-tight tracking-wide text-navy-950 transition-colors duration-150 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-[15px]" data-id="element-177" data-mp="21d5m2kssnqfq">
              Accedi al sistema — 19 EUR
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-178" data-mp="1ncl3npqsjwmr" />
            </a>
            <p className="pt-1.5 text-center text-[10px] font-semibold uppercase tracking-[0.14em] text-white/55" data-id="element-179" data-mp="3cs2g693u55ty">
              Pagamento unico · Accesso a vita · Cambio valuta automatico
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}